/**
 * @class MachineActionProgress
 */
export default class MachineActionProgress {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  rgb
     * @param {Number}  percentage
     * @param {Boolean} inProgress
     * @param {Boolean} done
     */
    constructor(id, name, rgb, percentage, inProgress, done) {
        this._id = id;
        this._name = name;
        this._rgb = rgb;
        this._percentage = percentage;
        this._inProgress = inProgress;
        this._done = done;
    }

    /**
     * @return {String}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {String} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get rgb() {
        return this._rgb;
    }

    /**
     * @param {String} rgb
     */
    set rgb(rgb) {
        this._rgb = rgb;
    }

    /**
     * @return {Number}
     */
    get percentage() {
        return this._percentage;
    }

    /**
     * @param {Number} percentage
     */
    set percentage(percentage) {
        this._percentage = percentage;
    }

    /**
     * @return {Boolean}
     */
    get inProgress() {
        return this._inProgress;
    }

    /**
     * @param {Boolean} inProgress
     */
    set inProgress(inProgress) {
        this._inProgress = inProgress;
    }

    /**
     * @return {Boolean}
     */
    get done() {
        return this._done;
    }

    /**
     * @param {Boolean} done
     */
    set done(done) {
        this._done = done;
    }

    /**
     * @return {String}
     */
    toString() {
        return "MachineActionProgress (" + this._id + ")";
    }
}
